import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
export const ResponsiveDivider = t0 => {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("h-80 shrink-0", "tablet:h-10 tablet:bg-Gray-100", "mobile:h-10 mobile:bg-Gray-100", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className={t1} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};